// utilities for navigation
import { navigate } from '@reach/router';

var nextSlide = function nextSlide(_ref) {
  var slug = _ref.slug,
      length = _ref.length,
      index = _ref.index,
      setState = _ref.setState;
  var n = index + 1;
  if (n >= length) return;
  navigate([slug, n].join('/'));
  setState({
    step: 0
  });
};

export var next = function next(context) {
  var steps = context.steps,
      step = context.step,
      setState = context.setState;
  if (!steps || step >= steps) return nextSlide(context);
  setState({
    step: step + 1
  });
};

var previousSlide = function previousSlide(_ref2) {
  var slug = _ref2.slug,
      index = _ref2.index,
      metadata = _ref2.metadata,
      setState = _ref2.setState;
  var n = index - 1;
  if (n < 0) return;
  navigate([slug, n].join('/'));

  var _ref3 = metadata[n] || {},
      _ref3$steps = _ref3.steps,
      steps = _ref3$steps === void 0 ? 0 : _ref3$steps;

  setState({
    step: steps
  });
};

export var previous = function previous(context) {
  var steps = context.steps,
      step = context.step,
      setState = context.setState;

  if (steps && step > 0) {
    return setState({
      step: step - 1
    });
  }

  previousSlide(context);
};